import {alpha, Box, Button, colors, Stack, Typography} from '@mui/material'
import {Trans} from 'react-i18next'
import {useAuthenticationContext, useUserContext} from '@goschool/auth'
import {PageLayout} from '@goschool/components'
import {CoursesPage} from '@goschool/courses'
import {Welcome} from '../branding'

export function LandingPage() {
  const {user, state} = useUserContext()
  const {signIn, signUp} = useAuthenticationContext()

  if (user == null || state === 'pending') {
    return <PageLayout fullScreen={true}>
      <Stack justifyContent="space-evenly" alignItems="center" flexGrow={1}>
        <BackgroundVideo src="/stdy.mp4"/>
        <Welcome/>
        <Stack direction="row" justifyContent="flex-start" my={2} gap={2}>

          <Stack gap={0.5} justifyContent="center" alignItems="center"
            visibility={state === 'pending' ? 'hidden' : 'visible'}>
            <Typography variant="caption" color="primary"><Trans i18nKey="auth:signUp.message"/></Typography>
            <Button size="small" variant="contained" color="primary" onClick={signUp}><Trans
              i18nKey="auth:signUp.cta"/></Button>
          </Stack>
          <Stack gap={0.5} justifyContent="center" alignItems="center"
            visibility={state === 'pending' ? 'hidden' : 'visible'}>
            <Typography variant="caption" color="primary"><Trans i18nKey="auth:signIn.message"/></Typography>
            <Button size="small" variant="outlined" color="primary" onClick={signIn}><Trans
              i18nKey="auth:signIn.cta"/></Button>
          </Stack>
        </Stack>
      </Stack>
    </PageLayout>
  }

  return <CoursesPage/>
}

function BackgroundVideo({
  src
}: {
  src: string
}) {
  return <>
    <video
      autoPlay
      muted
      playsInline
      style={{
        position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover',
        zIndex: 0
      }}>
      <source src={src} type="video/mp4"/>
      Your browser does not support the video tag.
    </video>

    <Box
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        background: `linear-gradient(
            to bottom,
            ${alpha(colors.blueGrey[100], 0.8)} 0%,
            ${alpha(colors.blueGrey[50], 0.9)} 33%,
            ${alpha(colors.blueGrey[50], 0.9)} 50%,
            ${alpha(colors.blueGrey[50], 0.9)} 67%,
            ${alpha(colors.blueGrey[100], 0.8)} 100%
          )`,
        zIndex: 0
      }}
    />
  </>

}
